// src/hooks/useKeyboardInset.js — how many px of the layout viewport the
// on-screen keyboard covers right now. Android 15 (targetSdk 35, edge-to-edge)
// often stops the WebView from resizing for the keyboard, leaving fixed
// bottom sheets/inputs underneath it. visualViewport reports the truth either
// way: overlap = layout height − visual height − visual top offset.
import { useState, useEffect } from 'react';

export function useKeyboardInset() {
  const [inset, setInset] = useState(0);

  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return undefined;
    const update = () => {
      const overlap = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
      // Ignore sub-keyboard noise (browser chrome show/hide).
      setInset(overlap > 60 ? Math.round(overlap) : 0);
    };
    vv.addEventListener('resize', update);
    vv.addEventListener('scroll', update);
    update();
    return () => { vv.removeEventListener('resize', update); vv.removeEventListener('scroll', update); };
  }, []);

  return inset;
}
